/**
 * The Symagic Server Shift entity
 * @author Maarten Lensink
 */
import { BreezeService } from '../../core/breeze.service';
/**
 * The Symagic Server Shift entity
 */
var Shift = /** @class */ (function () {
    function Shift() {
    }
    /**
     * Copies the shift into a new shift or shift template
     * @param newStart The date to which Start is shifted
     * @param include A string containing which entities, space separated, should be included in the copy
     * @param template Indicates whether the shift should be copied into a template
     * @param afterSave Indicates whether the method is invoked after properties changes are committed or before
     */
    Shift.prototype.copy = function (newStart, include, template, afterSave) {
        if (afterSave === void 0) { afterSave = false; }
        BreezeService.invokeMethod(this, 'Copy', [newStart, include, template], afterSave);
    };
    /**
     * Removes Taskneed instance from this object with taking into account situations of inherited collections.
     * @param {string} taskNeed The Oid of the Taskneed to remove.
     * @param {boolean} [afterSave=false] Indicates whether the method is invoked after properties changes are committed or before
     * @memberOf Shift
     */
    Shift.prototype.removeNeed = function (taskNeed, afterSave) {
        if (afterSave === void 0) { afterSave = false; }
        return BreezeService.invokeMethod(this, 'RemoveNeed', [taskNeed], afterSave);
    };
    return Shift;
}());
export { Shift };
